import React from 'react';

import {useWatch} from 'react-hook-form';


export const RhfWatcher = ({children, watchVals}) => {
  const watchedVals = useWatch({name: watchVals});
  return (
    <>
      {children(...watchedVals)}
    </>
  );
};
